module.exports = __webpack_public_path__ + "static/media/PortraitLeaderboard-10210.25b1cd99.jpg";